@if (!hasLoaded) {
  <div class="page-loader">
    <div>
      @if (title) {
        <div>
          @if (imgUrl) {
            <img class="page-loader__logo fade-in"
              [src]="imgUrl"
              [alt]="title">
          }
          @if (!imgUrl) {
            <h3
            [innerHTML]="title"></h3>
          }
        </div>
      }
      <div class="mt-5 p-large">
        <sb-icon name="loading"
        class="text-secondary"></sb-icon>
      </div>
    </div>
  </div>
}